import { Component, ElementRef, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
@Component({
  selector: 'privacy_policy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss'],
})
export class PrivacypolicyComponent implements OnInit {
  public privacyDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  images: any = [];
  constructor(public productService: ProductService, private elementRef: ElementRef) {}
  activeIndex: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  ngOnInit(): void {
    this.getPrivacyPolicyDetails();
    this.loadScripts();
  }
  getPrivacyPolicyDetails() {
    this.productService.getPrivacyPolicyDetails().subscribe((data) => {
      this.privacyDetails = data;
      this.images.push(this.privacyDetails.bannerImage);
    });
  }

  loadScripts() {
    var body = this.elementRef.nativeElement.querySelector('.privacyPolicy');
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    script.defer = true;
    script.lang = 'en';
    body.appendChild(script);
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
